import * as React from 'react';
import Base from './Base';
const Paragraph = React.forwardRef((props, ref) => {
    const { children, ...restProps } = props;
    return (React.createElement(Base, { ref: ref, ...restProps, component: "div" }, children));
});
export default Paragraph;
